// extracted by mini-css-extract-plugin
export var UserInfos__name = "UserInfos__name_GUWZZ";
export var post__content = "post__content_VU6ho";